<template>
  <nav
    v-if="listElements.length"
    id="pa-sidan-navigation"
    ref="paSidanNavigation"
    :class="isDesktopPageView ? 'desktop' : 'mobile'"
  >
    <Collapse
      id="pa-sidan-navigation-mobil-collapse"
      :showOnlyContent="isDesktopPageView"
      buttonClass="d-flex justify-content-between"
    >
      <template #button-content-before-icon>
        <span id="pa-sidan-navigation-rubrik">{{ titel }}</span>
      </template>
      <template #collapse-content>
        <h2 id="pa-sidan-navigation-rubrik" class="d-none d-xl-block">
          {{ titel }}
        </h2>
        <ul
          id="pa-sidan-navigation-lista"
          aria-labelledby="pa-sidan-navigation-rubrik"
        >
          <Listelement
            v-for="listelement in listElements"
            :ancorElementId="listelement.ancorElementId"
            :text="listelement.text"
            :isActive="listelement.isActive"
          />
        </ul>
      </template>
    </Collapse>
  </nav>
</template>

<script>
import Listelement from "./listelement.vue";
import Collapse from "../bootstrap/collapse.vue";
import Accordion from "../../script/accordion";

const ancorPointClassName = "ancor-point";
const ancorPointContainerClassName = "ancor-point-container";

const selectedAncorNrRemFromTop = 2;

var resizeObserver = undefined;
var resizeObserverElement = undefined;
var scrollObserverFunction = undefined;

export default {
  name: "PaSidanNavigation",
  props: {
    titel: String,
  },
  components: {
    Listelement,
    Collapse,
  },
  data: function () {
    return {
      isDesktopPageView: true,
      breakpoint: parseInt(
        getComputedStyle(document.body).getPropertyValue("--bs-breakpoint-xl")
      ),
      mainBodyElement: document.getElementById("mainBody"),
      listElements: [],
    };
  },

  created() {
    if (!this.mainBodyElement) {
      console.log("Error: PaSidanNavigation - MainBody saknas på sidan.");
      return;
    }
  },

  unmounted() {
    this.removeEventListeners();
  },

  mounted() {
    this.initNavingation();

    const self = this;
    document.addEventListener("personanpassatInnehallLaddat", function () {
      self.initNavingation();
      document.removeEventListener(
        "personanpassatInnehallLaddat",
        self.initNavingation()
      );
    });
  },
  methods: {
    initNavingation() {
      this.addAncorPointsInAncorPointContainers();
      this.removeAncorPointsInAccordions();
      this.listElements = this.createListElements();

      if (this.listElements.length) {
        this.isDesktopPageView ? this.setDesktopView() : this.setMobileView();
        this.handlePageResize();
        this.addEventListeners();
      }
    },

    addAncorPointsInAncorPointContainers() {
      var ancors = this.mainBodyElement.querySelectorAll(
        `.${ancorPointContainerClassName}>h2`
      );
      if (ancors) {
        ancors.forEach((ancor) => {
          ancor.classList.add(ancorPointClassName);
        });
      }
    },

    removeAncorPointsInAccordions() {
      Accordion.getAllAccordionsContent().forEach((accordionContent) => {
        accordionContent.forEach((accordionItem) => {
          accordionItem.classList.remove(ancorPointClassName);
          (
            accordionItem.querySelectorAll(`.${ancorPointClassName}`) ?? []
          ).forEach((ancorPoint) => {
            ancorPoint.classList.remove(ancorPointClassName);
          });
        });
      });
    },

    createListElements() {
      var listElements = [];
      var ancorPointElements = this.mainBodyElement.querySelectorAll(
        `h2.${ancorPointClassName}`
      );
      if (ancorPointElements.length) {
        ancorPointElements.forEach((ancorPointElement, i) => {
          //Makes sure that an id is given to ancor ponts without a pre-existing id.
          let ancorId = ancorPointElement.getAttribute("id");
          if (!ancorId) {
            ancorId = `${ancorPointClassName}-${i}`;
            ancorPointElement.setAttribute("id", ancorId);
          }

          listElements.push({
            ancorElementId: ancorId,
            text: ancorPointElement.textContent,
            isActive: false,
            ancorPointElement: ancorPointElement,
          });
        });
      }
      return listElements;
    },

    handlePageResize() {
      if (this.isDesktopPageView != window.innerWidth >= this.breakpoint) {
        this.isDesktopPageView ? this.setMobileView() : this.setDesktopView();
      }

      if (this.isDesktopPageView) {
        this.handelScroll();
      }
    },

    handelScroll() {
      if (this.isDesktopPageView) {
        let remToPxMultiplier = parseFloat(
          getComputedStyle(document.documentElement).fontSize
        );
        this.setActiveElementByScrollPosition(remToPxMultiplier);
      }
    },

    setActiveElementByScrollPosition(remToPxMultiplier) {
      let selectedAncorOffsetTop =
        selectedAncorNrRemFromTop * remToPxMultiplier;
      for (let i = 0; i < this.listElements.length; i++) {
        this.listElements[i].isActive =
          this.listElements[i].ancorPointElement.getBoundingClientRect().top <=
            selectedAncorOffsetTop &&
          (i == this.listElements.length - 1 ||
            this.listElements[i + 1].ancorPointElement.getBoundingClientRect()
              .top > selectedAncorOffsetTop);
      }
    },

    setDesktopView() {
      this.isDesktopPageView = true;
    },

    setMobileView() {
      this.listElements.forEach(
        (listelement) => (listelement.isActive = false)
      );
      this.isDesktopPageView = false;
    },

    addEventListeners() {
      this.removeEventListeners();
      resizeObserver = new ResizeObserver(() => this.handlePageResize());
      resizeObserverElement = this.mainBodyElement;
      resizeObserver.observe(resizeObserverElement);
      scrollObserverFunction = this.handelScroll;
      window.addEventListener("scroll", scrollObserverFunction);
    },

    removeEventListeners() {
      if (resizeObserver && resizeObserverElement) {
        resizeObserver.unobserve(resizeObserverElement);
        resizeObserver.disconnect();
      }

      if (scrollObserverFunction) {
        window.removeEventListener("scroll", scrollObserverFunction);
      }
    },
  },
};
</script>
